<template>
    <div class="bg-grey vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white pageDefault_UbahAbsensi">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left" @click="backtoDetailKehadiran">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">Ubah Absensi</div>
                <div class="header-top--right" @click="showpagesearch">
                    <div class="header-item">
                        <img src="../../../assets/icons/search.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <!-- SEARCH PAGE ABSENSI -->
        <div class="backgroundSearch pageSearchUbahAbsensi z-99">

            <div class="header-top bg-white pageSearchUbahAbsensi">
                <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                    <div class="header-top--left search-wrapper">
                        <input class="search-field" id="input_search_UbahAbsensi" type="text"
                               v-on:keyup="inputsearchUbahAbsensi"
                               v-model="searchKeyUbahAbsensi" placeholder="Cari.." autocomplete="off">
                    </div>
                    <div class="header-top--right">
                        <div class="header-item" @click="closesearchUbahAbsensi">
                            <img src="../../../assets/img/x2.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>

            <div id="loading-bar-spinner_absensi" class="spinner">
                <div class="spinner-icon"></div>
            </div>

            <div class="flex-1 main-page">
                <div class="w-limit p-y-16 p-x-20">
                    <div class="f-16 f-c-midgrey " id="textSearch_UbahAbsensi"></div>

                    <div class="card-item-wrapper m-t-16">

                        <div class="card-item" v-for="SearchUbahAbsen in UbahAbsensi_Search">
                            <div v-on:click="godetailAbsenPenggajian(SearchUbahAbsen)">

                                <div class="top-card">
                                    <div class="f-16 f-semi">{{SearchUbahAbsen.tanggal_format}}</div>
                                    <div class="card-chevron"></div>
                                </div>
                                <div class="f-14 f-c-midgrey m-t-4" v-if="SearchUbahAbsen.status===0">Tanpa Status</div>
                                <div class="f-14 f-c-midgrey m-t-4" v-if="SearchUbahAbsen.status===1">Masuk Kerja</div>
                                <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;"
                                     v-if="SearchUbahAbsen.status===2">Alpha
                                </div>
                                <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;"
                                     v-if="SearchUbahAbsen.status===3">Cuti
                                </div>
                                <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;"
                                     v-if="SearchUbahAbsen.status===4">Sakit
                                </div>
                                <div class="f-14 f-c-midgrey m-t-2">{{SearchUbahAbsen.waktu}}</div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page pageDefault_UbahAbsensi">
            <div class="p-x-20 p-y-16 w-limit">
                <div class="mar-bottom-16 w-limit">{{datafakturgaji.periode_format_Faktur}}</div>

                <div class="card-item-wrapper">

                    <div class="card-item" v-for="DatalistUbahAbsen in datafakturgaji.AbsensiFaktur"
                         @click="godetailAbsenPenggajian(DatalistUbahAbsen)">
                        <div class="top-card">
                            <div class="f-16 f-semi">{{DatalistUbahAbsen.tanggal_format}}</div>
                            <div class="card-chevron"></div>
                        </div>
                        <div class="f-14 f-c-midgrey m-t-4" v-if="DatalistUbahAbsen.status===0">Tanpa Status</div>
                        <div class="f-14 f-c-midgrey m-t-4" v-if="DatalistUbahAbsen.status===1">Masuk Kerja</div>
                        <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;" v-if="DatalistUbahAbsen.status===2">
                            Alpha
                        </div>
                        <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;" v-if="DatalistUbahAbsen.status===3">
                            Cuti
                        </div>
                        <div class="f-14 f-c-midgrey m-t-4" style="color: #EB5757;" v-if="DatalistUbahAbsen.status===4">
                            Sakit
                        </div>
                        <div class="f-14 f-c-midgrey m-t-2">{{DatalistUbahAbsen.waktu}}</div>
                    </div>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: 'UbahAbsensi',
        props: ['datafakturgaji', 'databayargaji'],
        data() {
            return {
                UbahAbsensi_Search: [],
                searchKeyUbahAbsensi: '',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            $(".pageSearchUbahAbsensi").prop("style", "display:none");
        },
        methods: {
            backtoDetailKehadiran() {
                this.$emit('backtodetailkehadiran')
            },

            godetailAbsenPenggajian(dataAbsen) {
                this.$emit('detailAbsenPenggajian', dataAbsen)
            },


            closesearchUbahAbsensi() {
                $(".pageSearchUbahAbsensi").hide();
                $(".pageDefault_UbahAbsensi").show();
                $("#textSearch_UbahAbsensi").text("");
                this.UbahAbsensi_Search = "";
                this.searchKeyUbahAbsensi = "";
            },

            showpagesearch() {
                $(".showPageSearch").addClass("animated slideInDown")
                $(".spinner").prop("style", "display:none");
                $("#textSearch_UbahAbsensi").text("Ketik minimal 2 karakter")
                $(".pageDefault_UbahAbsensi").hide();
                $(".pageSearchUbahAbsensi").show();
                $("#input_search_UbahAbsensi").focus();
            },

            inputsearchUbahAbsensi() {
                var input = this.searchKeyUbahAbsensi.replace(/[^0-9A-Za-z_.,' -]+/, '');
                this.searchKeyUbahAbsensi = input;
                this.searchDataUbahAbsensi()
            },

            searchDataUbahAbsensi() {
                $("#textSearch_UbahAbsensi").text("Minimal 2 karakter")
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.UbahAbsensi_Search = "";
                    $(".spinner").prop("style", "display:inline-block");
                    this.searchUbahAbsenisFunc();
                }, 500);
            },

            async searchUbahAbsenisFunc() {
                $("#textSearch_UbahAbsensi").text("Sedang mencari...");
                var key = this.searchKeyUbahAbsensi;
                this.UbahAbsensi_Search = [];
                if (key.length >= 2) {
                    try {
                        const response = await this.$axios.get(this.$baseurl + '/masterData/penggajian/meta/meta_absensi_faktur?idkaryawan='
                            + this.databayargaji.selected_karyawan_Faktur + '&tanggal_mulai=' + this.databayargaji.input_date_awal_Faktur
                            + '&tanggal_selesai=' + this.databayargaji.input_date_akhir_Faktur + '&key=' + key, this.requestHeaders);
                        if (response.status === 200) {
                            if (response.data.status === true) {
                                if (response.data.data.rekapabsen.length > 0) {
                                    $("#textSearch_UbahAbsensi").text("Ditemukan " + response.data.data.length +
                                        " Data dengan kata '" + key + "'")
                                    this.UbahAbsensi_Search = [];
                                    $('#loadingPage').hide();
                                    $('#loadingPage').removeClass('overlayLoading');
                                    var DataKaryawanABsen = response.data.data;
                                    var DataRekapabsen = response.data.data.rekapabsen;
                                    for (var i = 0; i < DataRekapabsen.length; i++) {
                                        this.UbahAbsensi_Search.push({
                                            tanggal: DataRekapabsen[i].tanggal,
                                            status: DataRekapabsen[i].status,
                                            waktu: DataRekapabsen[i].waktu,
                                            idkaryawan: DataRekapabsen[i].idkaryawan,
                                            tanggal_format: DataRekapabsen[i].tanggal_format,
                                            // idlokasi:DataRekapabsen[i].Idlokasi,
                                        })
                                    }
                                    $('#loadingPage').removeClass('overlayLoading');
                                    $('#loadingPage').hide()
                                } else {
                                    $("#textSearch_UbahAbsensi").text("Tidak menemukan '" + key + "'");
                                }
                                $(".spinner").prop("style", "display:none");
                            } else {

                            }
                        }
                    } catch (e) {
                        $(".spinner").prop("style", "display:none");
                        if (!e.code) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#alert').show()
                            $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                            $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                            setTimeout(() => {
                                $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                                $('#alert').addClass("alert alert-danger animated fadeOutUp");
                                setTimeout(() => {
                                    $('#alert').addClass("display-none")
                                }, 2000)
                            }, 30000)
                            if (e.response.status === 500) {
                                $('#loadingPage').hide();
                                $('#loadingPage').removeClass('overlayLoading');
                                $('#alert').show()
                                $('#contentAlert').text(e.response.data.msg);
                                $('#alert').removeClass("alert alert-danger animated fadeOutUp display-none");
                                $('#alert').addClass("alert alert-danger animated fadeInDown show-display");
                                setTimeout(() => {
                                    $('#alert').removeClass("alert alert-danger animated fadeInDown show-display");
                                    $('#alert').addClass("alert alert-danger animated fadeOutUp");
                                    setTimeout(() => {
                                        $('#alert').addClass("display-none")
                                    }, 2000)
                                }, 30000)
                            }
                        }
                    }
                } else {
                    this.UbahAbsensi_Search = "";
                    $(".spinner").prop("style", "display:none");
                    $("#textSearch_UbahAbsensi").text("Minimal 2 karakter")
                }
            },
        }
    }
</script>

<style>

</style>